import { SplunkLogEvent } from './splunk-log-event.model';
import { environment } from '../../../environments/environment';

export class SplunkPayload {

  event: SplunkLogEvent;
  index: string;
  source: string;
  sourcetype: string;
  host: string;

  constructor(data) {
    this.event = new SplunkLogEvent(data);
    this.index = environment.splunkMeta.index;
    if (data) {
      this.source = 'MYLIST';
      this.host = data.shopUid || '';
    }
    this.sourcetype = environment.splunkSourceEnv;
  }
}
